import "./platform.js";

SEOSnippetPreview.GooglePlatform = class extends SEOSnippetPreview.Platform {
  constructor(options) {
    super(
      {
        id: "google",
        title: "Google",
        targets: {
          title: 60,
          description: 135,
        },
        thresholds: {
          description: 20,
        },
      },
      options,
    );
  }

  render(title, description, url) {
    this.el.html(`
      <div class="google-snippet" data-behaviour="${this.options.editable ? "edit-snippet" : ""}">
        <div class="title">
          <span class="title-content">${title}</span>
        </div>
        <div class="url">
          ${url}
        </div>
        <div class="desc">
          ${description}
        </div>
      </div>
    `);

    return this;
  }
};
